<template>
  <div>
    <ask
      ref="processPayment"
      title="Process Payment"
      :message="
        'Are you sure you would like to process this payment for ' +
          $options.filters.currency(form.paymentAmount) +
          '?'
      "
      @ok="processPayment"
    ></ask>
    <div v-if="state.current == 'fillOut'">
      <validation-observer ref="formValidator" v-slot="{ handleSubmit }">
        <b-form
          role="form"
          @submit.prevent="handleSubmit(oneTimePaymentReview)"
        >
          <b-row>
            <b-col>
              <customer-saved-cards
                v-on:onCustomerCardSelect="onCustomerCardSelect"
                :customer="customer"
              />
            </b-col>
            <b-col>
              <base-input-currency
                class="mb-3"
                name="Payment Amount"
                ref="paymentAmount"
                rules="required|money"
                mode="lazy"
                prependChar="$"
                label="Payment Amount"
                :setNewValue="setNewPaymentValue"
                v-model="form.paymentAmount"
              />
            </b-col>
          </b-row>
          <br />
          <b-button class="btn-block" variant="primary" type="submit"
            >Review Payment</b-button
          >
        </b-form>
      </validation-observer>
    </div>
  </div>
</template>
<script>
import CustomerSavedCards from "@/views/Components/CustomerSavedCards";

export default {
  name: "pay-by-virtual",
  components: {
    CustomerSavedCards,
  },
  props: {
    customer: null,
    afterTransactionUri: null,
    giftCard: null,
    addAppts: null,
    amount: null,
  },
  watch: {
    amount: {
      handler: function(newVal, oldVal) {
        if (newVal && newVal > 0) {
          this.setNewPaymentValue = newVal / 100;
          this.form.paymentAmount = newVal / 100;
        }
      },
      immediate: true,
    },
  },
  data: function() {
    return {
      setNewPaymentValue: this.amount,
      state: {
        current: "fillOut",
      },
      form: {
        methodSelected: null,
        paymentAmount: null,
      },
    };
  },
  created() {
    var self = this;
  },
  mounted() {
    this.$refs.paymentAmount.$el.querySelector("input").focus();
    this.$refs.paymentAmount.$el.querySelector("input").select();
  },
  methods: {
    makeChanges() {
      this.state.current = "fillOut";
    },
    async processPayment() {
      var self = this;

      var form = {
        customerId: self.customer.id,
        amount: (self.form.paymentAmount * 100).toFixed(0),
        customerSavedCardId: self.form.methodSelected.id,
        giftCard: this.giftCard,
        addAppts: this.addAppts,
      };

      var r = await self.$client.post(
        "/api/virtualTerminal/processPayment",
        form
      );

      if (r.data.isSuccess) {
        if (r.data.value.isApproved) {
          self.$emitter.emit("success-confirm", {
            title: "Transaction Approved",
            message:
              "Transaction ID: " + r.data.value.transactionId.split("-")[0],
            navigate: this.afterTransactionUri,
          });
        } else {
          self.$emitter.emit("noSuccess-confirm", {
            title: "Transaction Declined",
            message: r.data.value.statusMessage,
          });
        }
      }
    },
    oneTimePaymentReview() {
      var self = this;

      self.$refs.processPayment.ask();
    },
    onCustomerCardSelect(patientCard) {
      this.form.methodSelected = patientCard;
    },
  },
};
</script>
